// extracted by mini-css-extract-plugin
export var animationContainer = "_pj-0";
export var footer = "_pj-1";
export var gray = "_pj-2";
export var lineItem = "_pj-3";
export var lineItemImage = "_pj-4";
export var lineItemInfo = "_pj-5";
export var lineItemText = "_pj-6";
export var lineItems = "_pj-7";
export var modalContent = "_pj-8";
export var options = "_pj-9";
export var orderName = "_pj-a";
export var refundAmount = "_pj-b";